<template>
  <div>
    <wh-popup
      v-model="myVisible"
      :ref-form="$refs.ProcessPopup"
      class="popup-page"
      title="加工环节"
      @close="hidePopup"
      @open="open"
    >
      <van-form
        ref="ProcessPopup"
        class="process-popup"
        label-width="60px"
        @submit="submitForm"
      >
        <div v-for="i in form.parPreparedProducts" :key="i.mngId" class="list-item">
          <div class="name-title">
            {{ i.name }}
          </div>
          <unit-title title="工序流程" />
          <div
            v-if="i.processJson.processingProcessInfo&&i.processJson.processingProcessInfo.length"
            class="process-list"
          >
            <div
              v-for="(item,key) in i.processJson.processingProcessInfo"
              :key="item.id"
              class="wh-flex-between process-item"
            >
              <div class="tag">
                <span class="wh-flex-center">{{ key + 1 }}</span>{{ item.processName }}
              </div>
              <div style="display: flex">
                操作人：{{ item.staffName }}
                <van-checkbox v-model="item.flag" style="margin-left: 5px" />
              </div>
            </div>
          </div>
          <unit-title title="原料追溯" />
          <div class="row-list ">
            <div v-for="(item,key) in i.rawMaterials" :key="key" class="row-item">
              <div class="row-line">
                <van-checkbox v-model="item.flag" style="margin-right: 5px" />
                <div class="cell">
                  <label>{{ item.materialName }}</label>
                  <img
                    v-if="item.traceCode"
                    alt=""
                    src="@/assets/images/productManage/right-white.png"
                    @click="handleClickEdit(item.traceCode)"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-form>
    </wh-popup>
    <packing-traceability-edit :form-type="trace.formType" :trace-code="trace.traceCode" :visible.sync="trace.visit" />
  </div>
</template>
<script>
import { firstImgThumb } from '@/filter'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import { formPopup } from '@/utils/mixins/formPopup'
import { formatTime } from '@/utils/convert/convertTime'
import UnitTitle from '@/views/productManage/TraceSource/components/UnitTitle'
import PackingTraceabilityEdit from '@/views/packing/TracePackingEdit/packingTraceabilityEdit'

export default {
  name: 'TraceProcessPopup',
  components: { WhPopup, UnitTitle, PackingTraceabilityEdit },
  filters: {
    firstImgThumb
  },
  mixins: [formPopup],
  data() {
    return {
      trace: {
        visit: false,
        traceCode: undefined,
        formType: 'edit'
      },
      form: {
        parPreparedProducts: []
      }
    }
  },
  methods: {
    formatTime,
    open() {
      this.form.parPreparedProducts = this.initFormData.parPreparedProducts
    },
    handleClickEdit(code) {
      // this.$router.push({ name: 'TraceSource', query: { traceCode: code }})
      this.trace.traceCode = code
      this.trace.visit = true
    },
    submitForm() {
      this.$emit('confirm', this.form)
      this.hidePopup()
    }
  }
}
</script>
<style lang="less" scoped>
.process-popup {
  padding: 10px 16px;
  .list-item {
    .name-title {
      font-size: 14px;
      font-weight: bold;
      color: #44B879;
      line-height: 22px;
    }
    .process-list {
      display: grid;
      grid-row-gap: 10px;
      .process-item {
        padding: 10px 12px;
        height: 36px;
        background: #ECF7F1;
        border-radius: 4px;
        .tag {
          span {
            display: inline-block;
            text-align: center;
            line-height: 16px;
            width: 20px;
            height: 16px;
            background: #44B879;
            color: #FFFFFF;
            border-radius: 2px 6px 2px 6px;
            margin-right: 8px;
          }
        }
      }
    }
    .row-list {
      width: 100%;
      display: grid;
      grid-row-gap: 12px;
      .row-item {
        height: 36px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;
        color: #404143;
        line-height: 22px;
        display: grid;
        grid-column-gap: 12px;
        .row-line {
          display: grid;
          grid-template-columns: auto 1fr;
          .cell {
            display: grid;
            padding: 0 12px;
            background: #ECF7F1;
            grid-template-columns: repeat(2, auto);
            justify-content: space-between;
            align-items: center;
            color: #44B879;
            label {
              font-size: 12px;
              font-weight: bold;
              position: relative;
              &::before {
                position: absolute;
                content: '·';
                font-weight: bold;
                font-size: 20px;
                left: -10px;
                color: #44B879;
                top: 0;
              }
            }
            img {
              width: 20px;
            }
          }
        }
      }
    }

  }
}
.popup-page {
  .process-popup {
    background: #f3f2f2;
    .list-item {
      background: #FFFFFF;
      box-shadow: 0 2px 12px 0 rgba(192, 203, 197, 0.4);
      margin-bottom: 12px;
      padding: 12px;
      border-radius: 12px;
    }
  }
}
</style>
